<template>
    <div class="animated fadeIn">
        <loading v-if="loading" message="Загружаем информацию о пользователе..."></loading>
        <div v-else class="row">
            <div class="col-12 col-lg-3">
                <div class="card">
                    <div class="row ml-0 mr-0">
                        <div class="card-block text-center col-md-5 col-lg-12">
                            <div class=" avatar-box">
                                <img
                                        @click="toggleShowAvatarModal"
                                        :src="getAvatarPath(user.avatar)" class="img-avatar">
                                <avatar-upload field="avatar"
                                               @crop-success="cropSuccess"
                                               @crop-upload-success="cropUploadSuccess"
                                               @crop-upload-fail="cropUploadFail"
                                               v-model="showAvatarModal"
                                               langType="ru"
                                               :width="300"
                                               :height="300"
                                               :url="getUploadUrl()"
                                               :headers="getHeaders()"
                                               :params="params"
                                               img-format="png"></avatar-upload>
                            </div>
                            <span class="badge badge-success" v-if="user.enabled">Активен</span>
                            <span class="badge badge-danger" v-else>Заблокирован</span>
                            <h4 class="card-title mb-0">{{user.fullname}}</h4>
                            <span class="badge badge-warning" v-for="role in user.roles">{{role.description}}</span>
                            <div v-if="currentUser.isAdmin && currentUser.id !== user.id" class="mt-1">
                                <loading v-if="blockUserLoading === user.id" :size="2" :message="false"></loading>
                                <template v-else>
                                    <button v-if="user.enabled" class="btn btn-danger btn-sm" @click="blockUser(user, false)">
                                        <i class="fa fa-lock"></i> Заблокировать
                                    </button>
                                    <button v-else class="btn btn-secondary btn-sm" @click="blockUser(user, true)">
                                        <i class="fa fa-unlock"></i> Разблокировать
                                    </button>
                                </template>
                            </div>
                        </div>
                        <div class="card-footer col-md-7 col-lg-12">
                            <div class="mb-1">
                                <span class="text-muted"><i class="fa fa-envelope-o" aria-hidden="true"></i> Электронная почта</span>
                                <h6>{{user.email}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.phone">
                                <span class="text-muted"><i class="fa fa-phone" aria-hidden="true"></i> Телефон</span>
                                <h6>+7{{user.phone}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.skype">
                                <span class="text-muted"><i class="fa fa-skype" aria-hidden="true"></i> Skype</span>
                                <h6>{{user.skype}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.icq">
                                <span class="text-muted">Icq</span>
                                <h6>{{user.icq}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.birthday">
                                <span class="text-muted"><i class="icon-calendar" aria-hidden="true"></i> День рождения</span>
                                <h6>{{user.birthday}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.companies.length">
                                <span class="text-muted"><i class="fa fa-building" aria-hidden="true"></i> Руководитель в компании</span>
                                <h6 v-for="company in user.companies">{{company.name}}</h6>
                            </div>
                            <div class="mb-1" v-if="user.techcenters.length">
                                <span class="text-muted"><i class="fa fa-building" aria-hidden="true"></i> Техцентры</span>
                                <h6 v-for="techcenter in user.techcenters">{{techcenter.city.name}}, {{techcenter.address}}</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-9">
                <b-card no-block>
                    <b-tabs card ref="tabs" v-model="tabIndex">
                        <b-tab title="<i class='fa fa-universal-access'></i> <span class='hidden-xs-down'>Активность</span>">
                            <timeline :user-id="user.id" v-if="tabIndex === 0"></timeline>
                        </b-tab>
                        <b-tab title="<i class='fa fa-user'></i> <span class='hidden-md-down'>Настройки профиля</span>
                                        <span class='hidden-lg-up hidden-sm-down'>Профиль</span>">
                            <profile-settings v-if="tabIndex === 1"></profile-settings>
                        </b-tab>
                        <b-tab title="<i class='fa fa-bell'></i> <span class='hidden-md-down'>Настройки уведомлений</span>
                                        <span class='hidden-lg-up hidden-sm-down'>Уведомление</span>">
                            <profile-notification-settings :user-id="user.id" v-if="tabIndex === 2"></profile-notification-settings>
                        </b-tab>
                        <b-tab title="<i class='fa fa-lock'></i> <span class='hidden-xs-down'>Безопасность</span>">
                            <security v-if="tabIndex === 3"></security>
                        </b-tab>
                        <b-tab title="<i class='fa fa-shield'></i> <span class='hidden-xs-down'>Права доступа</span>">
                            <permissions :user-id="user.id" v-if="tabIndex === 4"></permissions>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { ADD_TOAST_MESSAGE } from 'vuex-toast'
  import { storageUrl, getHeader } from './../config'
  import AvatarUpload from 'vue-image-crop-upload/upload-2.vue'
  import Timeline from './Profile/Timeline.vue'
  import ProfileSettings from './Profile/ProfileSettings.vue'
  import ProfileNotificationSettings from './Profile/ProfileNotificationSettings.vue'
  import Security from './Profile/Security.vue'
  import Permissions from './Profile/Permissions.vue'
  import blockUserMutate from './../gql/mutations/BlockUser.graphql'
  export default {
    computed: {
      ...mapState({
        user: state => state.userStore.user,
        currentUser: state => state.globalStore.user
      })
    },
    watch: {
      '$route': 'loadUserData'
    },
    data () {
      return {
        showAvatarModal: false,
        params: {
          name: 'avatar'
        },
        imgDataUrl: '', // the datebase64 url of created image,
        tabIndex: null,
        tabs: [],
        tabCounter: 0,
        loading: false,
        blockUserLoading: false
      }
    },
    name: 'profile',
    components: {
      AvatarUpload,
      Timeline,
      ProfileSettings,
      ProfileNotificationSettings,
      Security,
      Permissions
    },
    methods: {
      /**
       * Блокировка/разблокировка пользователя
       * @param user
       * @param enabled
       */
      blockUser (user, enabled) {
        this.blockUserLoading = user.id
        this.$apollo.mutate({
          mutation: blockUserMutate,
          variables: {
            id: user.id,
            enabled: enabled
          }
        }).then((result) => {
          this.$store.commit('UPDATE_VIEWED_USER', result.data.blockUser)
          this.addToast({
            text: 'Изменения сохранены',
            type: 'success',
            dismissAfter: 3000
          })
          this.blockUserLoading = false
        }).catch((error) => {
          console.error(error)
          this.addToast({
            text: 'Произошла ошибка:' + error,
            type: 'danger',
            dismissAfter: 10000
          })
          this.blockUserLoading = false
        })
      },
      toggleShowAvatarModal () {
        this.showAvatarModal = !this.showAvatarModal
      },
      getUploadUrl () {
        return storageUrl + '/api/user/' + this.user.id + '/upload-avatar'
      },
      getHeaders () {
        return getHeader()
      },
      loadUserData () {
        this.loading = true
        let id = null
        if (this.$route.name === 'ViewProfile') {
          id = this.$route.params.id
        }
        this.$store.dispatch('getUserById', id).then(() => {
          this.loading = false
        })
      },
      /**
       * Метод возвращает полный путь к аватарке пользователя
       * @param path
       * @return {string}
       */
      getAvatarPath (path) {
        return storageUrl + path
      },
      /**
       * crop success
       *
       * [param] imgDataUrl
       * [param] field
       */
      cropSuccess (imgDataUrl, field) {
        this.imgDataUrl = imgDataUrl
      },
      /**
       * upload success
       *
       * [param] jsonData   server api return data, already json encode
       * [param] field
       */
      cropUploadSuccess (result) {
        if (result.result) {
          this.$store.commit('UPDATE_VIEWED_AVATAR', result.filePath)
          if (this.currentUser.id === this.user.id) {
            this.$store.commit('UPDATE_AVATAR', result.filePath)
          }
          this.addToast({
            text: 'Автар успешно обновлен',
            type: 'success',
            dismissAfter: 3000
          })
        } else {
          this.addToast({
            text: 'Ошибка при загрузке аватара: ' + result,
            type: 'danger',
            dismissAfter: 3000
          })
        }
      },
      /**
       * upload fail
       *
       * [param] status    server api return error status, like 500
       * [param] field
       */
      cropUploadFail (status, field) {
        this.addToast({
          text: 'Ошибка при загрузке аватара: ' + status,
          type: 'danger',
          dismissAfter: 3000
        })
      },
      ...mapActions({
        addToast: ADD_TOAST_MESSAGE
      })
    },
    created () {
      this.loadUserData()
    }
  }
</script>
<style>
    .avatar-box .img-avatar {
        width: 200px;
        height: 200px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// Profile.vue?5bb2242a